export interface PagedList<T> {
   list: T[];
   page: number;
   pageSize: number;
   count: number;
}

export interface PaginationCriteria {
   page?: number;
   pageSize?: number;
   order?: string;
   sortReversed?: boolean;
   sortDirection?: string;
}